import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Text} from './styles';
import {theme} from '../../../styles/darkTheme';

interface Props {
  visible: boolean;
  title?: string;
  handleClose: () => void;
  children: React.ReactNode
}

const WebModal: React.FC<Props> = ({visible, children, title, handleClose}) => {
  return (
    <Modal show={visible} onHide={handleClose}>
      <Modal.Header closeButton>
        <Text theme={theme} type="bold">
          {title}
        </Text>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default WebModal;
